import Vue from "vue";
import store from "../../vuex/store";

export const getFilters = ({ dispatch }) => {
  dispatch("LOADING", false);
  Vue.http.get("api/v1/Products/Filter").then(function (response) {
    dispatch("FILTERS_LOADED", response.data);
  });
};

export const getFilteredImages = ({ dispatch }) => {
  var params = Vue.util.extend({}, store.state.filterParams);
  dispatch("FILTERED_IMAGES_LOADING");

  Vue.http.get("api/v1/Images", params).then(function (response) {
    dispatch("FILTERED_IMAGES_LOADED", response.data);
  });
};

export const updateOfferingFilter = ({ dispatch }, items) => {
  dispatch("UPDATE_OFFERING_FILTER", items);
  getFilteredImages({dispatch});
};

export const updateCategoriesFilter = ({ dispatch }, items) => {
  dispatch("UPDATE_CATEGORIES_FILTER", items);
  getFilteredImages({dispatch});
};

export const updateItemsFilter = ({ dispatch }, items) => {
  dispatch("UPDATE_ITEMS_FILTER", items);
  getFilteredImages({dispatch});
};

export const updateResolution = ({ dispatch }, items) => {
  dispatch("UPDATE_RESOLUTION_FILTER", items);
  getFilteredImages({dispatch});
};



// WEBPACK FOOTER //
// ./src/views/filter/FilterActions.js